import React from "react"

const Bio = ({ author }) => {
  // Veilig controleren of de avatar en naam beschikbaar zijn
  const avatarUrl = author?.avatar?.url
  const firstName = author?.firstName || "Onbekende auteur"
  const description = author?.description || "Deze auteur heeft nog geen biografie."

  return (
    <div className="bio bg-sky-200 p-6 rounded-lg shadow-md text-center flex flex-col items-center max-w-3xl mx-auto">
      {/* Titel bovenaan gecentreerd */}
      <h4 className="font-inter text-2xl font-semibold mb-6">Over de auteur</h4> 

      {/* Profielfoto in het midden */}
      {avatarUrl ? (
        <img
          alt={firstName}
          className="rounded-full object-cover w-20 h-20 border-2 border-white shadow-sm mb-4"
          src={avatarUrl}
          width={80}
          height={80}
        />
      ) : (
        <div className="w-20 h-20 rounded-full bg-gray-300 flex items-center justify-center text-gray-600 text-sm mb-4">
          N/A
        </div>
      )}

      {/* Auteur info */}
      <div className="text-center">
        <p className="text-lg font-semibold">{firstName}</p>
        <p className="text-gray-700 text-sm mt-2">{description}</p>
      </div>
    </div>
  )
}

export default Bio